/* eslint-disable max-len */
import { IconProps } from 'models/icons';
import React from 'react';

const TooltipFilled: React.FC<IconProps> = ({ ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2ZM9.99121 8.08887C9.59232 8.08898 9.26859 8.41262 9.26855 8.81152V13.6279C9.26871 14.0267 9.5924 14.3505 9.99121 14.3506C10.3901 14.3506 10.7137 14.0268 10.7139 13.6279V8.81152C10.7138 8.41255 10.3902 8.08887 9.99121 8.08887ZM9.99219 5.59961C9.54909 5.59987 9.19046 5.96017 9.19043 6.40332C9.1906 6.84635 9.54918 7.20579 9.99219 7.20605C10.4354 7.20605 10.7957 6.84652 10.7959 6.40332C10.7959 5.96 10.4355 5.59961 9.99219 5.59961Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default TooltipFilled;
